import React, {Fragment} from 'react';
import { Link } from 'react-router-dom';
import {connect} from 'react-redux';
import {INVENTORY_ROOMS} from "../../../constants";
import cx from "classnames";
import {getTotalCounts} from "../../../redux/reducers/inventory";
import {closeModal} from "../../../redux/actions/modals";
import '../sprites.css';

class InventoryView extends React.Component {

  render() {
    return (
      <Fragment>
        <header className="top-action-panel">
          <button className="close-reveal-modal" onClick={this.props.closeModal}>✖</button>
        </header>
        <div className="modal-body">
          
          <h3 className="title">My Inventory</h3>
          
          <div className="my-inventory-list">
            <p className="gray-subtitle">{ this.props.totalCount[0] } items in inventory</p>
            <div className="table-items-wrapper ">
              <ul className="table-items ">
                <li>
                  { Object.keys(this.props.inventoryItems).map( roomKey => {
                    if (Object.keys(this.props.inventoryItems[roomKey]).length > 0) {
                      return (
                        <ul key={roomKey} className="room-item">
                          <li className="table-category room-name">{INVENTORY_ROOMS[roomKey - 1] || 'OTHER ITEMS'}</li>
                          { Object.keys(this.props.inventoryItems[roomKey]).map( itemKey => {
                                return (
                                  <li key={itemKey} className="table-item table m-0">
                                    <ul className="item-list">
                                      <li className="item-details p-0">
                                        <div className={cx('image', 'p-0', 'd-inline-block', 'inventory-breakdown-icon', `${this.props.inventoryItems[roomKey][itemKey].icon_css_class}_small`)}/>
                                          <div className="info">
                                            <span className="name">{this.props.inventoryItems[roomKey][itemKey].name}</span>
                                            <br/>
                                            <span className="dimensions">{this.props.inventoryItems[roomKey][itemKey].description}</span>
                                          </div>
                                          <div className="item-count">
                                          {this.props.inventoryItems[roomKey][itemKey].mp_inventory_item_id.length}
                                          </div>
                                      </li>
  
                                    </ul>
                                  </li>
                                )
                            } )
                          
                          }
                        </ul>
                      )
                    } else return null
                  })}

                </li>
                <ul className="room-item">
                { Object.keys(this.props.customItems).length > 0 &&
                  Object.keys(this.props.customItems).map( itemKey => {
                    
                      return (
                        <Fragment key={itemKey}>
                          <li className="table-category room-name">CUSTOM ITEMS</li>
                          <li className="table-item table m-0">
                            <ul className="item-list">
                              <li className="item-details p-0">
                                <div className={cx('image', 'p-0', 'd-inline-block', 'inventory-breakdown-icon',
                                  `${this.props.customItems[itemKey].icon_css_class}_small`)}/>
                                <div className="info">
                                  <span className="name">{this.props.customItems[itemKey].name}</span>
                                  <br/><span className="dimensions">{this.props.customItems[itemKey].description}</span>
                                </div>
                                <div className="item-count">
                                  {this.props.customItems[itemKey].quantity}
                                </div>
                              </li>
                            </ul>
                          </li>
                        </Fragment>
                      )
                  })
                }
                </ul>


                <li className="table-category room-name">BOXES</li>
                          { Object.keys(this.props.boxes).map( itemKey => {
                                return (
                                  <li key={itemKey} className="table-item table m-0">
                                    <ul className="item-list">
                                      <li className="item-details p-0">
                                        <div className={cx('image', 'p-0', 'd-inline-block', 'inventory-breakdown-icon', `${this.props.boxes[itemKey].icon_css_class}_small`)}/>
                                          <div className="info">
                                            <span className="name">{this.props.boxes[itemKey].name}</span>
                                            <br/>
                                            <span className="dimensions">{this.props.boxes[itemKey].dimensions}</span>
                                          </div>
                                          <div className="item-count">
                                            {this.props.boxes[itemKey].quantity}
                                          </div>
                                      </li>
  
                                    </ul>
                                  </li>
                                )
                            } )
                          
                          }

                          

              </ul>
              <div className="scrollbar"></div>
              <p className="mt-5 gray-subtitle text-center"><Link to="/4/inventory/edit" onClick={this.props.closeModal}>EDIT</Link> this inventory</p>
            </div>
            
          </div>
        </div>
        {/* { this.props.totalCount[0] > 0 &&
          <footer className="confirmation-actions-save">
            <button className="green-long-button" onClick={() => alert('click')}>ADD ITEMS</button>
          </footer>
        } */}

        <style jsx>
          {`

            .table-items-wrapper {
                max-height: calc(100vh - 500px);
                border-width: 1px 0 1px 0;
                border-style: solid;
                border-color: #b2b2b2;
                overflow-y: scroll;
            }
            .table-item {
                border-bottom: 1px solid #dfdfdf;
            }
            .table-item:last-of-type {
              border-bottom: none;
            }
            .title {
                font-size: 22px;
                display: block;
                margin-bottom: 6px;
                text-transform: uppercase;
            }
            .cta-button {
                display: inline-block;
                padding: 9px 20px 6px;
                font-size: 15px;
            }
            .bottom-action-panel {
              display: flex;
              justify-content: flex-end;
            }
            .my-inventory-list {
                padding-bottom: 20px;
            }
            .list-count {
                font-size: 12px;
                padding: 5px 0 10px 0;
            }
            .room-item {
              display: grid;
              grid-template-columns: 1fr;
              padding-bottom: 30px
            }
            .table-category {
                font-family: "ProximaNovaBold", sans-serif;
                font-size: 11px;
                text-transform: uppercase;
                padding: 4px 0;
                border-bottom: 1px solid #dfdfdf;

            }
            .item-list {
                width: 100%;
                height: 50px;
                padding: 5px 0;
                align-items: center;
            }
            .item-details {
                display: flex;

            }
            .inventory-breakdown-icon {
                background-image: url(/assets/spritesheet-small.png);
                width: 40px;
                height: 40px;
            }
            .image {
                margin-left: 6px;
                vertical-align: middle;
            }

            .info {
                width: calc(100% - 70px);
                display: inline-block;
                line-height: 14px;
                padding-left: 15px;
                vertical-align: middle;
                margin: auto;
            }
            .name {
                font-size: 13px;
            }
            .dimensions {
                font-size: 12px;
                color: #747474;
            }

            .room-name {
              font-weight: 700;
              font-size: 1.6rem;
              padding: 10px 0;
              color: #12beeb;
              align-items: center;
              display: flex;
            }

            @media screen and (max-width: 40em) {
              .table-items-wrapper {
                max-height: calc(85vh - 150px);
              }
            }
            .inventory-box-icon {
              width: 4px;
              background-image: url(/assets/spritesheet-small.png);
            	height: 40px;
              margin-left: -15px;
            }

            .item-count {
              font-size: 2rem
            }

            `}
        </style>
      </Fragment>
    )
  }
}

const mapStateToProps = ({inventory}) => ({
  inventoryItems: inventory.inventoryItems,
  customItems: inventory.customItems,
  totalCount: getTotalCounts(inventory),
  specialHandlingItems: inventory.specialHandlingItems,
  boxes: inventory.inventoryBoxes,
});

export default connect(mapStateToProps,{
  closeModal
})(InventoryView);
